import type { ApiClient } from '@travel/api-client';

import { buildEndpoint, buildQueryString } from 'promotions/utils/searchVacantUtils';

import type { SearchVacantParams, SearchVacantResponse } from 'SearchVacant-Types';

export const getSearchVacantAPI = async (
  http: ApiClient,
  params: SearchVacantParams,
): Promise<SearchVacantResponse> => {
  const baseEndpoint = buildEndpoint(params.page, params.area);
  const queryString = buildQueryString(params);
  const endpoint = queryString ? `${baseEndpoint}?${queryString}` : baseEndpoint;

  // Only seed goes in request body, rest are query parameters
  return http.post(endpoint, {
    values: { seed: params.seed },
    customParams: { isTravelAPI: true },
  });
};
